import { setInstanceByEnvType } from "src/utils/helpers/requestApi/isServer";

interface GetProductPriceParams {
  product_slug: string;
  city_slug: string;
}

export interface ProductPriceSchema {
  min_price: number;
  max_price: number;
  offers_amount: number;
}

export const getProductPrice = (params: GetProductPriceParams) =>
  setInstanceByEnvType().get<ProductPriceSchema>(
    "/v2/catalog/product_page/price",
    {
      params,
    }
  );
